import { render, staticRenderFns } from "./ptcIndex.vue?vue&type=template&id=f4fca202&scoped=true&"
import script from "./ptcIndex.vue?vue&type=script&lang=js&"
export * from "./ptcIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fca202",
  null
  
)

export default component.exports